interface AvatarProps {
  /** Used for the initials when there is no picture. */
  name: string
  /** Small inline picture (data URL), or null/absent for initials. */
  avatar?: string | null
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const SIZES: Record<NonNullable<AvatarProps['size']>, string> = {
  sm: 'h-6 w-6 rounded-lg text-[10px]',
  md: 'h-8 w-8 rounded-xl text-xs',
  lg: 'h-20 w-20 rounded-2xl text-xl',
}

function initialsOf(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part[0])
    .slice(0, 2)
    .join('')
    .toUpperCase()
}

/**
 * The profile picture, or initials when there is none (D-44).
 *
 * One component so the bar, the account table and the profile screen can never disagree
 * about how a person looks. The image is decorative (`alt=""`) because the name is always
 * rendered next to it in text.
 */
export function Avatar({ name, avatar, size = 'md', className = '' }: AvatarProps) {
  const base = `flex shrink-0 items-center justify-center overflow-hidden bg-gradient-to-br from-slate-700 to-slate-900 font-semibold text-white dark:from-salsa-600 dark:to-salsa-800 ${SIZES[size]} ${className}`

  if (avatar) {
    return <img src={avatar} alt="" className={`${base} object-cover`} />
  }
  return (
    <span className={base} aria-hidden="true">
      {initialsOf(name)}
    </span>
  )
}